import { Box, Container, Typography } from "@mui/material";
import { useDocumentTitle } from "../../utils/data";

const Healthcare = () => {
  useDocumentTitle("Briozon - Healthcare Solutions");

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, sm: 8, md: 10 } }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 3, color: "#1a1a1a" }}>
          Healthcare Solutions
        </Typography>
        <Typography variant="body1" sx={{ color: "#666", fontSize: { xs: "16px", sm: "19px", md: "20px" } }}>
          This page is under construction.
        </Typography>
      </Box>
    </Container>
  );
};

export default Healthcare;
